module.exports = __webpack_public_path__ + "assets/jenkins.1b567055.svg";